type LogLevel = 'debug' | 'info' | 'warn' | 'error'

function emit(level: LogLevel, scope: string, message: string, ...args: unknown[]) {
  if (!scope.trim()) return
  const prefix = `[${scope}] ${message}`
  switch (level) {
    case 'debug':
      if (import.meta.env.DEV) console.debug(prefix, ...args)
      return
    case 'info':
      console.info(prefix, ...args)
      return
    case 'warn':
      console.warn(prefix, ...args)
      return
    case 'error':
      console.error(prefix, ...args)
      return
  }
}

export function createLogger(scope: string) {
  return {
    debug: (message: string, ...args: unknown[]) => emit('debug', scope, message, ...args),
    info: (message: string, ...args: unknown[]) => emit('info', scope, message, ...args),
    warn: (message: string, ...args: unknown[]) => emit('warn', scope, message, ...args),
    error: (message: string, ...args: unknown[]) => emit('error', scope, message, ...args),
  }
}

